// extracted by mini-css-extract-plugin
export default {"c-dialog":"vKjfy","enter":"_tSpS","enter-active":"_rzju","exit-active":"_WLUO"};